module.exports = __webpack_public_path__ + "static/media/11.visual-studio-code.ed9a98f7.svg";